import { render } from "./MySplashAdsView.vue?vue&type=template&id=23dcb846&scoped=true"
import script from "./MySplashAdsView.vue?vue&type=script&lang=js"
export * from "./MySplashAdsView.vue?vue&type=script&lang=js"

import "./MySplashAdsView.vue?vue&type=style&index=0&id=23dcb846&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23dcb846"]])

export default __exports__